export default __webpack_public_path__ + "static/media/new_motionCoin.acbdbfb3.png";